<script setup lang="ts">
import { newsletter } from '../../../content'
</script>

<template>
  <section id="newsletter" class="newsletter">
    <div class="container">
      <h3 class="newsletter__title animate animate--fade-up">{{ newsletter.headline }}</h3>
      <p class="newsletter__description animate animate--fade-up animate--delay-1">{{ newsletter.lead }}</p>

      <form class="newsletter__form animate animate--fade-up animate--delay-2" @submit.prevent>
        <input
          type="email"
          class="newsletter__input"
          :placeholder="newsletter.placeholder"
          required
        >
        <button type="submit" class="btn btn--primary">
          {{ newsletter.buttonLabel }}
        </button>
      </form>
    </div>
  </section>
</template>
